var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 153,
    viewBox: "0 0 100 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0829 12.0229L62.2672 3.43511L55.3843 8.01527L50.0886 0L44.8006 8.01527L37.9101 3.43511L35.102 12.0229L27.5781 9.73282L32.2863 26.0534H50.0886H67.8986L72.6067 9.73282L65.0829 12.0229Z",
    fill: "#CEB388"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.112 18.458C39.5359 18.458 30.959 20.2443 30.959 22.4427V37.9924H69.265V22.4427C69.2421 20.2443 60.6728 18.458 50.112 18.458Z",
    fill: "#CEB388"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0885 41.9698C60.6665 41.9698 69.2415 40.1892 69.2415 37.9927C69.2415 35.7962 60.6665 34.0156 50.0885 34.0156C39.5106 34.0156 30.9355 35.7962 30.9355 37.9927C30.9355 40.1892 39.5106 41.9698 50.0885 41.9698Z",
    fill: "#4B4B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 123.885L50.0038 152.763L100 123.885V66.1296L50.0038 37.2441L0 66.1296V123.885Z",
    fill: "url(#paint0_linear_1729_86)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1009 111.45V104.405H35.2285V98.8142L51.7939 78.9326H58.0311V98.0762H63.6647L60.8703 104.405H58.0311V111.45H51.1009ZM51.1009 98.0762V89.1083L43.6565 98.0762H51.1009Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_86",
    x1: 50,
    y1: 37.2441,
    x2: 50,
    y2: 152.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAAF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D99E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel4);
export default __webpack_public_path__ + "static/media/_level-4.4c8fc14bef1d6f54f54bb6e58b0ef481.svg";
export { ForwardRef as ReactComponent };